import { useEffect, useState } from 'react';
import { TFeathersContextSocket } from '../types';
import { createFeathersSocketClient } from '../initialContextState';

/*
const useSingleStrategy = (socketUrl: string) => {
  return createFeathersClient(socketUrl);
};//*/

const useReconnectStrategy = (socketUrl?: string) => {
  const [feathersContext, setFeathersContext] = useState<
    TFeathersContextSocket | undefined
  >(undefined);

  useEffect(() => {
    const client = createFeathersSocketClient(socketUrl);
    const { sid, socket } = client;

    function listener(event: any, ...args: any[]) {
      // console.log(event, sid, args);
    }

    socket.onAny(listener);
    socket.connect();
    setFeathersContext(client);
    return () => {
      socket.offAny(listener);
      socket.disconnect();
    };
  }, [socketUrl, setFeathersContext]);

  return feathersContext;
};

const useFeathersSocketIOClient = (socketUrl: string) => {
  return useReconnectStrategy(socketUrl);
};

export default useFeathersSocketIOClient;
